import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {ProcessFlowchartValidationError} from 'processes/graph-builder-processes/validation/ProcessFlowchartForValidationTypes';
import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';

export function ValidationErrorRenderer(props: {
  validationErrors: Array<ProcessFlowchartValidationError>;
}): JSX.Element {
  const uniqueValidationErrors = props.validationErrors.reduce((acc, error) => {
    if (!acc.some((e) => e.errorType === error.errorType)) {
      acc.push(error);
    }
    return acc;
  }, [] as Array<ProcessFlowchartValidationError>);
  const shouldShowValidationErrors = uniqueValidationErrors.length > 0;
  return (
    <>
      {shouldShowValidationErrors &&
        uniqueValidationErrors.map((error) => (
          <div className={css(styles.errorBannerContainer)} key={error.errorMessage}>
            <InlineBanner
              bannerType={InlineBannerType.ERROR}
              text={error.errorTitle ?? null}
              supportingInfo={error.errorMessage}
            />
          </div>
        ))}
    </>
  );
}
const styles = StyleSheet.create({
  errorBannerContainer: {
    marginBottom: '16px',
  },
});
